var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"poster"},[_c('div',{staticStyle:{"width":"100%","display":"flex","justify-content":"center"}},[_c('img',{attrs:{"src":_vm.imgPath,"width":"375px","alt":""}})]),_c('record-poster',{ref:"clazzPoster",attrs:{"poster-data":_vm.recordPosterData},on:{"success":_vm.success,"fail":_vm.fail}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }